// /**
//  * Variant Card Spreader (Featured Only)
//  * Version 5.0 - Anti-Flash Curtain (Smooth Fade-in)
//  * 
//  * ROOT CAUSE OF "DOUBLE FLASH" (Fixed in v5.0):
//  * The order of execution caused a visible jump. Globo injected HTML -> 
//  * browser painted it -> Sale/Wishlist scripts modified DOM -> Spreader sorted it.
//  *
//  * SOLUTION:
//  * We use a MutationObserver that detects when Globo injects new products, and
//  * INSTANTLY (before the browser paints) applies a curtain class to hide the cards 
//  * (opacity: 0). We then wait for Sale/Wishlist scripts to finish (500ms), sort 
//  * the DOM under the curtain, and finally fade them in smoothly.
//  */
// (function () {
//     const DEBUG = false;
//     const WAIT_FOR_OTHER_SCRIPTS = 500;  // wait for collection.js sale filter (50ms) + buffer
//     const COOLDOWN_MS = 2000;            // ignore triggers for 2s after a successful sort
//     const SAFETY_TIMEOUT_MS = 1500;      // fallback reveal if sort fails

//     function log(msg, ...args) {
//         if (DEBUG) console.log(`%c[Spreader] ${msg}`, 'color: #ff00ff; font-weight: bold;', ...args);
//     }

//     // --- UTILS ---

//     function getSortParam() {
//         return new URLSearchParams(window.location.search).get('sort_by');
//     }

//     function isTargetSort() {
//         const s = getSortParam();
//         return s === null || s === '' || s === 'featured' || s === 'bestmatch';
//     }

//     function isCollectionPage() {
//         const p = window.location.pathname;
//         return p.includes('/collections/') && !p.includes('/products/'); // Target PLP
//     }

//     function getGrid() {
//         return document.querySelector('#gf-products, #product-grid, ul#product-grid');
//     }

//     function fingerprint(grid) {
//         if (!grid) return '';
//         const els = grid.querySelectorAll(':scope > li.grid__item [data-product-id]');
//         let fp = '';
//         els.forEach(el => { fp += el.dataset.productId + ','; });
//         return fp;
//     }

//     // --- INJECT CSS ---
    
//     function injectStyles() {
//         if (document.getElementById('vcs-styles')) return;
//         const style = document.createElement('style');
//         style.id = 'vcs-styles';
//         style.innerHTML = `
//             /* Variant Card Spreader - Anti-Flash Curtain */
//             .vcs-sorting > .grid__item {
//                 opacity: 0 !important;
//                 transform: translateY(15px) !important;
//                 pointer-events: none !important;
//                 transition: none !important;
//             }
//             .vcs-sorted > .grid__item {
//                 opacity: 1 !important;
//                 transform: translateY(0) !important;
//                 transition: opacity 0.5s ease-out, transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) !important;
//             }
//             /* Staggered fade in for organic feel */
//             .vcs-sorted > .grid__item:nth-child(2n) {
//                 transition-delay: 0.05s !important;
//             }
//             .vcs-sorted > .grid__item:nth-child(3n) {
//                 transition-delay: 0.1s !important;
//             }
//         `;
//         document.head.appendChild(style);
//     }

//     // --- WAVE SORT ---

//     function waveSort(cards) {
//         const counts = {};
//         const data = cards.map((card, i) => {
//             const w = card.querySelector('[data-product-id]');
//             const id = w ? w.dataset.productId : null;
//             let wave = 0;
//             if (id) {
//                 counts[id] = counts[id] || 0;
//                 wave = counts[id];
//                 counts[id]++;
//             }
//             return { card, i, wave };
//         });

//         data.sort((a, b) => a.wave !== b.wave ? a.wave - b.wave : a.i - b.i);
//         return data.map(d => d.card);
//     }

//     // --- CURTAIN SYSTEM ---

//     let gridObserver = null;
//     let fallbackTimeout = null;

//     function dropCurtain(grid) {
//         if (!grid) return;
//         log('Dropping curtain (hiding cards)');
//         grid.classList.remove('vcs-sorted');
//         grid.classList.add('vcs-sorting');
        
//         // Safety net: force reveal if sorting never happens
//         clearTimeout(fallbackTimeout);
//         fallbackTimeout = setTimeout(() => revealCurtain(grid), SAFETY_TIMEOUT_MS);
//     }

//     function revealCurtain(grid) {
//         if (!grid) return;
//         clearTimeout(fallbackTimeout);
//         if (grid.classList.contains('vcs-sorting')) {
//             log('Raising curtain (revealing cards)');
//             grid.classList.remove('vcs-sorting');
//             // Force browser repaint before adding sorted class
//             void grid.offsetWidth; 
//             grid.classList.add('vcs-sorted');
//         }
//     }

//     function setupObserver() {
//         const grid = getGrid();
//         if (!grid) {
//             setTimeout(setupObserver, 200);
//             return;
//         }

//         if (gridObserver) gridObserver.disconnect();

//         gridObserver = new MutationObserver((mutations) => {
//             let shouldCurtain = false;
//             for (let m of mutations) {
//                 // If Globo injects a bunch of new product cards
//                 if (m.type === 'childList' && m.addedNodes.length > 2) {
//                     shouldCurtain = true;
//                     break;
//                 }
//             }

//             if (shouldCurtain && isTargetSort()) {
//                 dropCurtain(grid);
//             }
//         });

//         gridObserver.observe(grid, { childList: true, subtree: false });
//     }

//     // --- SINGLE PROCESS CONTROLLER ---

//     let timer = null;
//     let lastFingerprint = '';
//     let lastSortTime = 0;

//     function schedule(reason) {
//         if (!isCollectionPage() || !isTargetSort()) {
//             log(`Skip schedule: not applicable (${reason})`);
//             const grid = getGrid();
//             if (grid) revealCurtain(grid); // ensure it's not stuck hidden
//             return;
//         }

//         if (reason !== 'Load' && (Date.now() - lastSortTime) < COOLDOWN_MS) {
//             log(`Cooldown active, ignoring: ${reason}`);
//             return;
//         }

//         log(`Scheduled: ${reason}`);

//         clearTimeout(timer);

//         const delay = reason === 'Load' ? 100 : WAIT_FOR_OTHER_SCRIPTS;
//         timer = setTimeout(() => doSort(reason), delay);
//     }

//     function doSort(reason) {
//     console.time(`variant-card-spreader (${reason})`);

//     const grid = getGrid();
//     if (!grid) {
//         console.timeEnd(`variant-card-spreader (${reason})`);
//         return;
//     }

//     const cards = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
//     if (cards.length < 3) {
//         revealCurtain(grid);
//         console.timeEnd(`variant-card-spreader (${reason})`);
//         return;
//     }

//     const fp = fingerprint(grid);
//     if (fp === lastFingerprint && reason !== 'Load') {
//         log('Skip: identical fingerprint');
//         revealCurtain(grid);
//         console.timeEnd(`variant-card-spreader (${reason})`);
//         return;
//     }

//     const sorted = waveSort(cards);

//     let changed = false;
//     for (let i = 0; i < sorted.length; i++) {
//         if (sorted[i] !== cards[i]) {
//             changed = true;
//             break;
//         }
//     }

//     if (!changed) {
//         log('Skip: cards already in correct order');
//         lastFingerprint = fp;
//         lastSortTime = Date.now();
//         revealCurtain(grid);
//         console.timeEnd(`variant-card-spreader (${reason})`);
//         return;
//     }

//     const frag = document.createDocumentFragment();
//     sorted.forEach(card => frag.appendChild(card));
//     grid.appendChild(frag);

//     lastFingerprint = fingerprint(grid);
//     lastSortTime = Date.now();

//     revealCurtain(grid);

//     console.timeEnd(`variant-card-spreader (${reason})`);
// }

//     // --- INIT ---

//     function init() {
        
//         if (!isCollectionPage()) return;

//         injectStyles();
//         setupObserver();

//         if (document.readyState === 'loading') {
//             document.addEventListener('DOMContentLoaded', () => {
//                 const grid = getGrid();
//                 if (grid && isTargetSort()) dropCurtain(grid);
//                 schedule('Load');
//             }, { once: true });
//         } else {
//             const grid = getGrid();
//             if (grid && isTargetSort()) dropCurtain(grid);
//             schedule('Load');
//         }

//         window.addEventListener('globoFilterRenderCompleted', () => {
//             // Curtain is typically dropped by MutationObserver earlier, 
//             // but drop again here safely just in case it missed it.
//             const grid = getGrid();
//             if (grid && isTargetSort() && !grid.classList.contains('vcs-sorting')) {
//                 dropCurtain(grid);
//             }
//             schedule('GloboRender');
//         });

//         document.addEventListener('change', (e) => {
//             if (e.target.closest('.sort-by') || e.target.id === 'sort-by-dropdown' || e.target.id === 'sort-by-dropdown-mobile') {
//                 lastFingerprint = '';
//                 schedule('SortChange');
//             }
//         });

//         window.addEventListener('popstate', () => {
//             lastFingerprint = '';
//             schedule('PopState');
//         });
//     }

//     init();
// })();


/**
 * Variant Card Spreader
 * ULTRA OPTIMIZED + FULL DEBUG VERSION
 */

(function () {

const DEBUG = false;

const console = DEBUG
	? window.console
	: {
			log() {},
			warn() {},
			time() {},
			timeEnd() {},
			group() {},
			groupEnd() {}
		};

const WAIT_FOR_OTHER_SCRIPTS = 500;
const COOLDOWN_MS = 2000;
const SAFETY_TIMEOUT_MS = 1500;

function log(...args){
if(DEBUG) console.log("%c[VCS]", "color:#ff00ff;font-weight:bold;", ...args);
}

function group(name){
if(DEBUG) console.group(name);
}

function groupEnd(){
if(DEBUG) console.groupEnd();
}

/* ---------------- UTILS ---------------- */

function getSortParam(){

console.time("getSortParam");

const v=new URLSearchParams(location.search).get("sort_by");

console.timeEnd("getSortParam");

return v;

}

function isTargetSort(){

console.time("isTargetSort");

const s=getSortParam();

const r=(s===null||s===""||s==="featured"||s==="bestmatch");

console.timeEnd("isTargetSort");

return r;

}

function isCollectionPage(){

console.time("isCollectionPage");

const p=location.pathname;

const r=p.includes("/collections/")&&!p.includes("/products/");

console.timeEnd("isCollectionPage");

return r;

}

function getGrid(){

console.time("getGrid");

const g=document.querySelector("#gf-products,#product-grid,ul#product-grid");

console.timeEnd("getGrid");

return g;

}

/* ---------------- FINGERPRINT ---------------- */

function fingerprint(grid){

console.time("fingerprint");

const nodes=grid.querySelectorAll(':scope > li.grid__item [data-product-id]');

let fp="";

for(let i=0;i<nodes.length;i++){

fp+=nodes[i].dataset.productId+",";

}

console.timeEnd("fingerprint");

return fp;

}

/* ---------------- CSS ---------------- */

function injectStyles(){

console.time("injectStyles");

if(document.getElementById("vcs-styles")){
console.timeEnd("injectStyles");
return;
}

const style=document.createElement("style");

style.id="vcs-styles";

style.textContent=`

.vcs-sorting>.grid__item{
opacity:0!important;
transform:translateY(15px)!important;
pointer-events:none!important;
transition:none!important;
}

.vcs-sorted>.grid__item{
opacity:1!important;
transform:translateY(0)!important;
transition:opacity .45s ease-out,transform .45s cubic-bezier(.2,.8,.2,1)!important;
}

.vcs-sorted>.grid__item:nth-child(2n){
transition-delay:.04s!important;
}

.vcs-sorted>.grid__item:nth-child(3n){
transition-delay:.08s!important;
}

`;

document.head.appendChild(style);

console.timeEnd("injectStyles");

}

/* ---------------- WAVE SORT ---------------- */

function waveSort(cards){

console.time("waveSort");

const counts={};

const data=new Array(cards.length);

for(let i=0;i<cards.length;i++){

const card=cards[i];

const w=card.querySelector("[data-product-id]");

const id=w?w.dataset.productId:null;

let wave=0;

if(id){

counts[id]=counts[id]||0;

wave=counts[id];

counts[id]++;

}

data[i]={card,i,wave};

}

data.sort((a,b)=>a.wave!==b.wave?a.wave-b.wave:a.i-b.i);

const result=new Array(data.length);

for(let i=0;i<data.length;i++) result[i]=data[i].card;

console.timeEnd("waveSort");

return result;

}

/* ---------------- CURTAIN ---------------- */

let fallbackTimeout=null;

function dropCurtain(grid){

console.time("dropCurtain");

log("Curtain DROP");

grid.classList.remove("vcs-sorted");

grid.classList.add("vcs-sorting");

clearTimeout(fallbackTimeout);

fallbackTimeout=setTimeout(()=>{

console.warn("Curtain safety reveal triggered");

revealCurtain(grid);

},SAFETY_TIMEOUT_MS);

console.timeEnd("dropCurtain");

}

function revealCurtain(grid){

console.time("revealCurtain");

clearTimeout(fallbackTimeout);

if(!grid.classList.contains("vcs-sorting")){

console.timeEnd("revealCurtain");

return;

}

requestAnimationFrame(()=>{

log("Curtain REVEAL");

grid.classList.remove("vcs-sorting");

grid.classList.add("vcs-sorted");

console.timeEnd("revealCurtain");

});

}

/* ---------------- OBSERVER ---------------- */

let gridObserver=null;

function setupObserver(){

console.time("setupObserver");

const grid=getGrid();

if(!grid){

setTimeout(setupObserver,200);

console.timeEnd("setupObserver");

return;

}

if(gridObserver) gridObserver.disconnect();

gridObserver=new MutationObserver((mutations)=>{

console.time("MutationObserver");

let shouldCurtain=false;

for(let i=0;i<mutations.length;i++){

const m=mutations[i];

if(m.type==="childList" && m.addedNodes.length>2){

shouldCurtain=true;

break;

}

}

if(shouldCurtain && isTargetSort()){

log("Mutation detected → curtain drop");

dropCurtain(grid);

}

console.timeEnd("MutationObserver");

});

gridObserver.observe(grid,{childList:true});

console.timeEnd("setupObserver");

}

/* ---------------- CONTROLLER ---------------- */

let timer=null;
let lastFingerprint="";
let lastSortTime=0;

function schedule(reason){

group("schedule "+reason);

console.time("schedule");

if(!isCollectionPage()||!isTargetSort()){

const grid=getGrid();

if(grid) revealCurtain(grid);

console.timeEnd("schedule");

groupEnd();

return;

}

if(reason!=="Load" && (Date.now()-lastSortTime)<COOLDOWN_MS){

log("cooldown active");

console.timeEnd("schedule");

groupEnd();

return;

}

clearTimeout(timer);

const delay=reason==="Load"?100:WAIT_FOR_OTHER_SCRIPTS;

log("schedule delay",delay);

timer=setTimeout(()=>doSort(reason),delay);

console.timeEnd("schedule");

groupEnd();

}

/* ---------------- MAIN SORT ---------------- */

function doSort(reason){

group("doSort "+reason);

console.time("doSort TOTAL");

const grid=getGrid();

if(!grid){

console.timeEnd("doSort TOTAL");

groupEnd();

return;

}

console.time("queryCards");

const cards=Array.from(grid.querySelectorAll(':scope > li.grid__item'));

console.timeEnd("queryCards");

log("card count",cards.length);

if(cards.length<3){

revealCurtain(grid);

console.timeEnd("doSort TOTAL");

groupEnd();

return;

}

const fp=fingerprint(grid);

if(fp===lastFingerprint && reason!=="Load"){

log("fingerprint identical skip");

revealCurtain(grid);

console.timeEnd("doSort TOTAL");

groupEnd();

return;

}

console.time("sorting");

const sorted=waveSort(cards);

console.timeEnd("sorting");

console.time("orderCheck");

let changed=false;

for(let i=0;i<sorted.length;i++){

if(sorted[i]!==cards[i]){

changed=true;

break;

}

}

console.timeEnd("orderCheck");

if(!changed){

log("order already correct");

lastFingerprint=fp;

lastSortTime=Date.now();

revealCurtain(grid);

console.timeEnd("doSort TOTAL");

groupEnd();

return;

}

console.time("DOM reorder");

const frag=document.createDocumentFragment();

for(let i=0;i<sorted.length;i++){

frag.appendChild(sorted[i]);

}

grid.appendChild(frag);

console.timeEnd("DOM reorder");

lastFingerprint=fingerprint(grid);
lastSortTime=Date.now();

revealCurtain(grid);

console.timeEnd("doSort TOTAL");

groupEnd();

}

/* ---------------- INIT ---------------- */

function init(){

console.time("init");

log("initializing");

if(!isCollectionPage()){

console.timeEnd("init");

return;

}

injectStyles();

setupObserver();

if(document.readyState==="loading"){

document.addEventListener("DOMContentLoaded",()=>{

const grid=getGrid();

if(grid && isTargetSort()) dropCurtain(grid);

schedule("Load");

},{once:true});

}else{

const grid=getGrid();

if(grid && isTargetSort()) dropCurtain(grid);

schedule("Load");

}

window.addEventListener("globoFilterRenderCompleted",()=>{

log("globoFilterRenderCompleted");

const grid=getGrid();

if(grid && isTargetSort() && !grid.classList.contains("vcs-sorting")){

dropCurtain(grid);

}

schedule("GloboRender");

});

document.addEventListener("change",(e)=>{

if(
e.target.closest(".sort-by") ||
e.target.id==="sort-by-dropdown" ||
e.target.id==="sort-by-dropdown-mobile"
){

lastFingerprint="";

schedule("SortChange");

}

});

window.addEventListener("popstate",()=>{

lastFingerprint="";

schedule("PopState");

});

console.timeEnd("init");

}

init();

})();